import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { fetchSubscriptionAccess } from "../../services/razorpayService";
import SubscriptionExpiredDialog, {
  formatExpiryDateForDisplay,
} from "../Subscription/SubscriptionExpiredDialog";

export default function ProtectedRouteSubscriptionGate({ children }) {
  const navigate = useNavigate();
  const [gate, setGate] = useState(null);
  const [expiryFormatted, setExpiryFormatted] = useState(null);
  const [planName, setPlanName] = useState(null);
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      setGate(null);
      setExpiryFormatted(null);

      const userId = localStorage.getItem("user_id");
      if (!userId) {
        setGate("subscribe");
        return;
      }

      try {
        const sub = await fetchSubscriptionAccess(userId);
        setPlanName(sub?.planName);
        if (cancelled) return;
        switch (sub.access) {
          case "allow":
            setGate("allow");
            break;

          case "expired":
            setExpiryFormatted(
              formatExpiryDateForDisplay(sub.expiryRaw)
            );
            setGate("expired");
            break;

          case "pending":
            setGate("pending");
            break;

          default:
            setGate("subscribe");
        }
      } catch (err) {
        console.error("Subscription check failed:", err.message);
        if (!cancelled) setGate("subscribe");
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRenewSubscription = () => {
    setExpiryFormatted(null);
    navigate("/subscribe");
  };

  // 🔄 Loading state (important UX)
  if (gate === null) {
    return <div>Checking subscription...</div>;
  }

  // ❌ No subscription
  if (gate === "subscribe") {
    return <Navigate to="/subscribe" replace />;
  }

  // ⏳ Payment in progress
  if (gate === "pending") {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h3>Payment in progress</h3>
        <p>Please complete your subscription payment.</p>
      </div>
    );
  }

  // ❌ Expired
  if (gate === "expired") {
    return (
      <SubscriptionExpiredDialog
        open
        onRenew={handleRenewSubscription}
        expiryDateFormatted={expiryFormatted}
        planName={planName}
      />
    );
  }

  return children;
}
